/* eslint-disable max-len */
export const sampleScheduleTypesList = {
  meta: {
    count: 2016,
    page: 1,
    pagesize: 10,
    columns: [
      {
        key: 'title',
        title: ' Schedule Title',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'type',
        title: 'Type',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'frequency',
        title: 'Frequency',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'recurs',
        title: 'Recurs Every',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'occursonce',
        title: 'Occurs once',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'occursEvery',
        title: 'Occur Every',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'time',
        title: 'Time',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      }
    ]
  },
  data: [
    {
      id: 1,
      title: 'PM_Daily_Recuring_2days',
      type: 'Recuring ',
      frequency: 'Daily',
      recurs: '3 Day',
      occursonce: 'HH:MM:SS',
      occursEvery: '3 hrs',
      time: 'HH:MM:SS to :HH:MM:SS',
      startAt: '10:00:00',
      endAt: '12:00:00',
      allowBufferHours: '3',
      allowBufferMinute: '10'
    },
    {
      id: 2,
      title: 'PM_Monthly_RelRecurring_2mon',
      type: 'Relative recuring',
      frequency: 'Weekly',
      recurs: '2 Day',
      occursonce: 'HH:MM:SS',
      occursEvery: '',
      time: 'HH:MM:SS to :HH:MM:SS',
      startAt: '10:30:00',
      endAt: '12:30:00',
      allowBufferHours: '3',
      allowBufferMinute: '10'
    },
    {
      id: 3,
      title: 'Weekly PM3',
      type: 'One Time',
      frequency: 'Monthly',
      recurs: '3 Day',
      occursonce: 'HH:MM:SS',
      occursEvery: '3hrs',
      time: 'HH:MM:SS to :HH:MM:SS',
      startAt: '11:00:00',
      endAt: '01:00:00',
      allowBufferHours: '3',
      allowBufferMinute: '10'
    },
    {
      id: 4,
      title: 'PM_Weekly_Once_10days',
      type: 'Recuring',
      frequency: 'Bi-Weekly',
      recurs: '4 Day',
      occursonce: 'HH:MM:SS',
      occursEvery: '4 hrs',
      time: 'HH:MM:SS to :HH:MM:SS',
      startAt: '02:00:00',
      endAt: '04:00:00',
      allowBufferHours: '3',
      allowBufferMinute: '10'
    }
  ]
};

export const dropDownOptions = {
  recursType: [
    {
      id: 1,
      recur: 'One Time'
    },
    { id: 2, recur: 'Recurring' },
    { id: 3, recur: 'Relative recurring' }
  ],

  frequencyType: [
    { id: 1, frequency: 'Daily' },
    {
      id: 2,
      frequency: 'Weekly'
    },
    {
      id: 3,
      frequency: 'Monthly'
    }
  ]
};
